var breakpoints = {
  small: 768,
  large: 1024
};
var MediaQueries = {
  desktopOnly: "@media only screen and (min-width: ".concat(breakpoints.large + 1, "px)"),
  desktopAndTablet: "@media only screen and (min-width: ".concat(breakpoints.small, "px)"),
  tabletOnly: "@media only screen and (min-width: ".concat(breakpoints.small, "px) and (max-width: ").concat(breakpoints.large, "px)"),
  tabletAndPhone: "@media only screen and (max-width: ".concat(breakpoints.large, "px)"),
  phoneOnly: "@media only screen and (max-width: ".concat(breakpoints.small - 1, "px)")
};
export default MediaQueries;